<template>
    <div class="page-header clear-filter" filter-color="orange">
        <div
                class="page-header-image"
                style="background-image: url('img/login.jpg')"
        ></div>
        <div class="content">
            <div class="container">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                     width="80" height="80"
                     viewBox="0 0 80 80"
                     style=" fill:#000000;">
                    <path fill="#f5ce85" d="M16.5 60.5H63.5V67.5H16.5z"></path>
                    <path fill="#967a44" d="M63,61v6H17v-6H63 M64,60H16v8h48V60L64,60z"></path>
                    <path fill="#f78f8f"
                          d="M40,25.5c-6.341,0-11.5-5.159-11.5-11.5S33.659,2.5,40,2.5S51.5,7.659,51.5,14S46.341,25.5,40,25.5z"></path>
                    <path fill="#c74343"
                          d="M40,3c6.065,0,11,4.935,11,11s-4.935,11-11,11s-11-4.935-11-11S33.935,3,40,3 M40,2 c-6.627,0-12,5.373-12,12s5.373,12,12,12s12-5.373,12-12S46.627,2,40,2L40,2z"></path>
                    <path fill="#fff" d="M34 12H46V16H34z"></path>
                    <path fill="#f5ce85" d="M8.5 41.143H17.5V77.5H8.5z"></path>
                    <path fill="#967a44" d="M17,41.643V77H9V41.643H17 M18,40.643H8V78h10V40.643L18,40.643z"></path>
                    <path fill="#f5ce85" d="M62.5 41.143H71.5V77.5H62.5z"></path>
                    <path fill="#967a44" d="M71,41.643V77h-8V41.643H71 M72,40.643H62V78h10V40.643L72,40.643z"></path>
                    <path fill="#f78f8f" d="M2.5 24.5H77.5V43.5H2.5z"></path>
                    <path fill="#c74343" d="M77,25v18H3V25H77 M78,24H2v20h76V24L78,24z"></path>
                    <path fill="#fff"
                          d="M42.615 25L30.154 43 36.385 43 48.846 25zM11.462 25L3 37.222 3 43 5.231 43 17.692 25zM27.038 25L14.577 43 20.808 43 33.269 25zM77 25L73.769 25 61.308 43 67.538 43 77 29.333zM58.192 25L45.731 43 51.962 43 64.423 25z"></path>
                </svg>
                <p style="color: white">Page Not Found</p>


                <img src="img/404.png" alt="Page Not Found" width="40%" style="margin-top: 3em">


                <div class="col-md-5 ml-auto mr-auto">
                </div>
            </div>
        </div>
<!--        <main-footer></main-footer>-->
    </div>
</template>
<script>
    import {Card, Button, FormGroupInput} from '@/components';
    import MainFooter from '@/layout/MainFooter';

    export default {
        name: 'login-page',
        bodyClass: 'login-page',
        components: {
            Card,
            MainFooter,
            [Button.name]: Button,
            [FormGroupInput.name]: FormGroupInput
        }
    };
</script>
<style>
    .scaling-svg-container {
        position: relative;
        height: 0;
        width: 100%;
        padding: 0;
        padding-bottom: 100%;
        /* override this inline for aspect ratio other than square */
    }

    .scaling-svg {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
    }
</style>
